import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Store } from '@ngrx/store';

import { IChannel } from '../../interfaces/IChannel';
import { setChannelInfo } from '../../store/chat.actions';
import { AppStateWithChat } from '../../store/chat.reducer';

function customDisplayNameValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const displayName: string = control.value as string;
  if (displayName === 'N/A' || displayName === 'Orphan message') {
    return { invalidDisplayName: true };
  }
  return null;
}

@Component({
  selector: 'ngx-channel-edit-form',
  templateUrl: './channel-edit-form.component.html',
  styleUrls: ['./channel-edit-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ChannelEditFormComponent {
  private fb = inject(FormBuilder);
  private store = inject(Store<AppStateWithChat>);
  private dialogRef = inject(MatDialogRef<ChannelEditFormComponent>);
  data = inject<{ channel: IChannel }>(MAT_DIALOG_DATA);

  newChatForm: FormGroup = this.fb.group({
    displayName: [this.data.channel.displayName, [Validators.required, customDisplayNameValidator]],
  });

  save(): void {
    this.store.dispatch(
      setChannelInfo({
        channel: this.data.channel,
        displayName: this.newChatForm.value['displayName'] as string,
      })
    );
    this.close();
  }

  close(): void {
    this.dialogRef.close();
  }
}
